export function JntLogo() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="40"
      height="40"
      role="img"
      aria-label="J&T Express"
    >
      <rect width="64" height="64" rx="14" fill="#E60012" />
      <text
        x="32"
        y="38"
        textAnchor="middle"
        fontFamily="'Helvetica Neue', Helvetica, Arial, sans-serif"
        fontWeight="800"
        fontSize="19"
        fill="#FFFFFF"
        letterSpacing="-0.5"
      >
        {"J&T"}
      </text>
    </svg>
  );
}
